import React, {useState} from 'react';
import {useForm} from "react-hook-form";
import {Helmet} from "react-helmet";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import moment from "moment/moment";
import LoadingButton from "../../base/components/loadingButton";
import {Table} from "reactstrap";
import axios from "../../../helpers/axios";
import {Form} from "react-bootstrap";
import numberFormat from "../../../helpers/numberFormat";
import _, {values} from 'lodash'
import RenderGroup from "../components/renderGroup";
import CreateCategoryForm from "../components/createCategoryForm";

const Consumption = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const [internalTransfers, setInternalTransfers] = useState(false)
  const [categories, setCategories] = useState()
  const [notSorteredData, setNotSorteredData] = useState()
  const defaultVal= {
    start: moment().subtract(7, 'days').format('DD.MM.YYYY'),
    end: moment().format('DD.MM.YYYY'),
  }
  const formController = useForm({defaultValues:defaultVal})
  const {handleSubmit} = formController

  const filterByCategory = (array,categories) =>{
    const withCategory = categories.map(c=>({
        name: c.label,
        total: 0,
        values: [],
        id: c.value,
        type: 'category'
      }))
    const withoutCategory = array.filter(item=>{
      const categoryName = _.find(categories, c=>c.children.includes(item.name))?.label
      if(categoryName){
        const itemCat = withCategory.find(c=>c.name === categoryName)
        itemCat.values.push({...item, categoryId:itemCat.id })
        itemCat.total = item.total+itemCat.total
        return false
      }
      return true
    })
    withoutCategory.unshift({
      name:'Без категории',
      total: _.sumBy(withoutCategory, 'total'),
      values:[],
      type:'category'
    })
    return [...withCategory,...withoutCategory]
  }
  const submit = (data) =>{
    setLoading(true)
    axios.post('/api/fromOneC/consumption', data).then(({data})=>{
      setCategories(data.categories)
      const groupdSuppliers =_.groupBy( _.filter(data.oneC, {type:'Оплата поставщику'}),'counterparty.name' )
      let dataOneC = []
      Object.keys(groupdSuppliers).forEach(key=>{
        dataOneC.push({
          name: key,
          total:  _.sumBy(_.filter(groupdSuppliers[key], {toOurBank: false}), 'summ'),
          values: groupdSuppliers[key]
        })
      })
      const other = _.filter(data.oneC, (t)=>t.type !== 'Оплата поставщику')
      const grouppedOther = _.groupBy(other, 'type')
      console.log(grouppedOther)
      dataOneC.push(...Object.keys(grouppedOther).map(key=>{
        return {
          name: key,
          total:  _.sumBy(_.filter(grouppedOther[key]), 'summ'),
          values: grouppedOther[key]
        }
      }))
      const groupGoogle = _.groupBy(data.google, 'counterparty.name')
      const dataGoogle= []
      const googleTotal = ()=>{
        return Object.keys(_.groupBy(data.google, 'currency')).map((key, i) => {
          return <div key={i}>
            {numberFormat(_.sumBy(_.groupBy(data.google, 'currency')[key], 'summ'))} {key}
          </div>
        })
      }
      Object.keys(groupGoogle).forEach(key=>{
        dataGoogle.push({
            name: key,
            total:  _.sumBy(_.filter(groupGoogle[key]), 'summ'),
            values: groupGoogle[key]
          })
      })
      setNotSorteredData(dataOneC)
      setData({google: dataGoogle, oneC: filterByCategory(dataOneC,data.categories), googleTotal})
    })
      .finally(()=>setLoading(false))
  }
console.log('data', data)
  const somthingWithCategory = (data) =>{

    const setInfo = (data) =>{
      setCategories(data.data)
      if (notSorteredData){
        setData(old=>({...old, oneC: filterByCategory(notSorteredData,data.data)}))
      }
    }
    setLoading(true)
    console.log(data)
    if(data.type === 'add'){
      axios.put('/api/fromOneC/consumption/categories', data)
        .then(({data})=>{
          setInfo(data)
        }).finally(()=>setLoading(false))
    }else if (data.type === 'delete'){
      axios.delete('/api/fromOneC/consumption/categories/'+data.id)
        .then(({data})=>{
          setInfo(data)
        }).finally(()=>setLoading(false))
    } else{
      axios.post('/api/fromOneC/consumption/categories/'+data.id, data)
        .then(({data})=>{
          console.log(data)
          setInfo(data)
        }).finally(()=>setLoading(false))
    }

  }
  const ourTrans = ['Взнос наличными в банк','Перевод на другой счет организации']

  return (
    <>
      <Helmet><title>Расходы</title></Helmet>
      <Portlet>
        <PortletHeader title={<div className={'d-flex align-items-center gap-2 justify-content-between'}>
          <div>Расходы</div>
          {data && <CreateCategoryForm somthingWithCategory={somthingWithCategory}/>}
        </div>} toolbar={<PortletHeaderToolbar>
          <form onSubmit={handleSubmit(submit)} className={'d-flex gap-2'}>
            <CustomDatePicker formController={formController}
                              label={"Дата c"}
                              value={defaultVal.start}
                              name={`start`}
                              rules={{required: true}}/>
            <CustomDatePicker formController={formController}
                              label={"Дата по"}
                              value={defaultVal.end}
                              name={`end`}
                              rules={{required: true}}/>
            <LoadingButton loading={loading} title={'Получить'}/>
          </form>
          </PortletHeaderToolbar>}/>
        {data && <div className={'tableFixOnlyHead'} >
          <Table bordered size={'sm'}>
            <thead>
            <tr>
              <th></th>
              <th>Дата</th>
              <th>Комму</th>
              <th>Тип</th>
              <th>Cумма</th>
              <th>Вал</th>
              <th>Комментарий</th>
            </tr>
            </thead>
            <tbody>
            <tr style={{backgroundColor: "#9ac8f3"}}>
              <th colSpan={4} style={{paddingLeft: '1rem'}}>1c</th>
              <th className={'text-center'}>{numberFormat(
                _.sumBy(data.oneC,data => {
                  if(data.name !== "Без категории" && data.name !== "Прочее" && ourTrans.includes(data.name)){
                    return data.total
                  }
                })
              )}</th>
              <th>KZT</th>
              <td><Form.Label className={'d-flex align-items-center gap-2'}>
                <input
                  defaultChecked={internalTransfers}
                  onChange={(e) => {
                    setInternalTransfers(!internalTransfers)
                  }}
                  type={"checkbox"}
                />
                Показать внутренние транзакции
              </Form.Label></td>
            </tr>

            {data.oneC.map((table,index)=>{
              if(ourTrans.includes(table.name) && !internalTransfers){
                return
              } else {
                return <React.Fragment key={index} >
                  <RenderGroup table={table} somthingWithCategory={somthingWithCategory} categories={categories}/>
                </React.Fragment>
              }
            })}
            <tr style={{backgroundColor: "#9ac8f3"}}>
              <th colSpan={4} style={{paddingLeft: '1rem'}}>Google касса</th>
              <th colSpan={3}>
                <div className={'d-flex gap-2'}>
                  <div>Итого:</div>
                  {data.googleTotal()}</div>
              </th>

            </tr>
            {data.google.map((table, i) => {
              return <React.Fragment key={i} >
                <RenderGroup table={table} fromGoogle/>
              </React.Fragment>
            })}
            </tbody>
          </Table>
        </div>}
      </Portlet>
    </>
  );
};

export default Consumption;
